import {useSearchParams} from 'next/navigation';
import {getCommonQueryParams, getFilterOptionsBySearchParams} from '../helpers/product-filter.helpers';

export const useProductFilter = () => {
    const query = useSearchParams();
    const filterOptions = getFilterOptionsBySearchParams(query);
    const {page, search, sort} = getCommonQueryParams(query);

    return {
        initialFilterOptions: filterOptions,
        initialPage: page,
        initialSearch: search,
        initialSort: sort,
    };
};
